import { createSlice } from 'utils/@reduxjs/toolkit';
import { ConfiguratorDataState } from './types';
import { reducers } from './reducers';

export const initialState: ConfiguratorDataState = {
  isLoading: false,
  data: {
    items: [],
    filterAttributes: [],
    total: 0,
  },
  error: null,
  displaySafetyFactor: 0,
  isApiComplete: false,
  mountingApply: false,
};

const slice = createSlice({
  name: 'configuratorData',
  initialState,
  reducers,
});

export const { actions: configuratorDataActions } = slice;
export const { reducer: configuratorDataReducer } = slice;
